import * as React from 'react';
import { throttle } from 'lodash';

export default (element: HTMLDivElement | null, throttleInterval = 0) => {
    const [height, setHeight] = React.useState(0);
    const [width, setWidth] = React.useState(0);

    const throttledSetSize = React.useMemo(
        () =>
            throttle((newHeight, newWidth) => {
                setHeight(newHeight);
                setWidth(newWidth);
            }, throttleInterval),
        [throttleInterval]
    );

    React.useEffect(() => {
        const setInitialSize = () => {
            if (element) {
                const rect = element.getBoundingClientRect();
                throttledSetSize(rect.height, rect.width);
            }
        };

        setInitialSize();

        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                const rect = entry.target.getBoundingClientRect();
                throttledSetSize(rect.height, rect.width);
            }
        });

        if (element) {
            resizeObserver.observe(element);
        }

        return () => {
            resizeObserver.disconnect();
        };
    }, [element, throttledSetSize]);

    return {
        height,
        width
    };
};
